import React from 'react';
import { Box, Grid, Typography } from '@mui/material';

/**
 * A simple layout component that organizes form fields into sections arranged horizontally
 * @param {Object} props
 * @param {Array} props.sections - Array of section objects with title and fields
 */
const SectionedFormLayout = ({ sections = [] }) => {
    if (!sections.length) {
        return null;
    }

    return (
        <Box sx={{ p: 1 }}>
            {sections.map((section, index) => (
                <Box key={section.title || `section-${index}`} sx={{ mb: 1, backgroundColor: '#fafafa', borderRadius: 1 }}>
                    {section.title && (
                        <Typography 
                            variant="h6" 
                            sx={{ 
                                mb: 1, 
                                fontWeight: 500,
                                borderBottom: '1px solid #ddd',
                            }}
                        >
                            {section.title}
                        </Typography>
                    )}
                    <Grid container spacing={2}>
                        {section.fields && section.fields.map((field, fieldIndex) => (
                            <Grid 
                                item 
                                xs={12} 
                                sm={6} 
                                md={4} 
                                key={fieldIndex}
                            >
                                <Box sx={{ 
                                    p: 1,
                                    '& .MuiFormControl-root': { 
                                        width: '100%',
                                        '& .MuiInputLabel-root': {
                                            position: 'static',
                                            transform: 'none',
                                            fontSize: '0.875rem',
                                            fontWeight: 500,
                                            color: 'text.secondary',
                                            marginBottom: '4px'
                                        },
                                        '& .MuiInputLabel-shrink': {
                                            transform: 'none'
                                        }
                                    } 
                                }}>
                                    {field}
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            ))}
        </Box>
    );
};

export default SectionedFormLayout;
